var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex ls-box"},[_c('el-avatar',{attrs:{"icon":"el-icon-user-solid","src":_vm.item.pic}}),_c('div',{staticClass:"ml-10"},[_c('div',[_vm._v(" "+_vm._s(_vm.item.user_name)),_c('br'),_vm._v(" "+_vm._s(_vm.item.phone)+" ")]),_c('div',{staticClass:"f-129"},[_vm._v(" "+_vm._s(_vm.item.address)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }